import { Platform, PopupEvent, usePopupConnection, } from '@fractalwagmi/popup-connection';
import { FractalSDKContext } from "../../context/fractal-sdk-context.js";
import { FractalSDKError } from "../../core/error/index.js";
import { FractalSDKOnrampAuthError, FractalSDKOnrampUnknownError, } from "../../core/error/onramp.js";
import { useCallback, useContext, useEffect } from 'react';
const ONRAMP_URL = 'https://fractal.is/onramp';
const MIN_POPUP_HEIGHT_PX = 672;
const MAX_POPUP_WIDTH_PX = 800;
export const useOnramp = ({ onFulfillmentComplete, onRejected, theme } = {
    theme: 'light',
}) => {
    const { clientId, user } = useContext(FractalSDKContext);
    const { connection, open: openPopup } = usePopupConnection({
        enabled: !user,
        heightPx: Math.max(MIN_POPUP_HEIGHT_PX, Math.floor(window.innerHeight * 0.8)),
        platform: Platform.REACT_SDK,
        widthPx: Math.min(MAX_POPUP_WIDTH_PX, Math.floor(window.innerWidth * 0.6)),
    });
    const handleOnRejected = useCallback((err) => {
        const onrampErr = asOnrampError(err);
        onRejected === null || onRejected === void 0 ? void 0 : onRejected(onrampErr);
    }, [onRejected]);
    useEffect(() => {
        if (!connection) {
            return;
        }
        if (onFulfillmentComplete) {
            connection.on(PopupEvent.ONRAMP_FULFILLMENT_COMPLETE, onFulfillmentComplete);
        }
        if (onRejected) {
            connection.on(PopupEvent.ONRAMP_REJECTED, handleOnRejected);
        }
        return () => {
            if (!connection) {
                return;
            }
            if (onFulfillmentComplete) {
                connection.off(PopupEvent.ONRAMP_FULFILLMENT_COMPLETE, onFulfillmentComplete);
            }
            if (onRejected) {
                connection.off(PopupEvent.ONRAMP_REJECTED, handleOnRejected);
            }
        };
    }, [connection, handleOnRejected, onFulfillmentComplete, onRejected]);
    const openOnrampWindow = useCallback(async () => {
        if (!user) {
            throw new FractalSDKOnrampAuthError('User must be signed in to a Fractal Wallet to start an onramp session');
        }
        openPopup(`${ONRAMP_URL}?clientId=${clientId}&theme=${theme}`);
    }, [clientId, openPopup, theme, user]);
    return { openOnrampWindow };
};
function asOnrampError(err) {
    if (err instanceof FractalSDKError) {
        return err;
    }
    return new FractalSDKOnrampUnknownError(`An unknown error occurred during the onramp session. err = ${err}`);
}
//# sourceMappingURL=use-onramp.js.map